var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"row"},[_c('div',{staticClass:"col-12"},[_c('b-button',{on:{"click":function($event){return _vm.$modal.show(_vm.name)}}},[_vm._v("\n            "+_vm._s(_vm.button_title)+"\n        ")]),_c('ModalComponent',{attrs:{"name":_vm.name,"title":_vm.title},on:{"close":() => _vm.cerrar()}},[_vm._t("default")],2)],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }